import * as React from "react";
import { viewDateTimeUtc, viewDateUtc } from "src/common/dateTime";

import { ZAttrMeta } from "../ZAttrMeta";
import { ZAttrValue } from "../ZAttrValue";

type PropsAttrViewText = {
  value: ZAttrValue;
  meta: ZAttrMeta;
};

export const AttrViewText: React.FC<PropsAttrViewText> = ({ value, meta }) => {
  const onNumber = (numValue: number | null): string => {
    if (numValue === null) return "";
    if (meta.type.name === "number") {
      const { precision } = meta.type;
      if (precision) {
        return numValue.toFixed(precision);
      }
    }
    return numValue.toString();
  };
  const onDate = (src: string | null): string => {
    if (!src) return "";
    if (meta.type.name === "dateTime") {
      return meta.type.dateOnly ? viewDateUtc(src) : viewDateTimeUtc(src);
    }
    return src;
  };
  switch (value.type) {
    case "string":
      return value.value;
    case "number":
      return onNumber(value.value);
    case "strOption":
      return value.value?.label;
    case "boolean":
      return JSON.stringify(value.value);
    case "dateTime":
      return onDate(value.value);
    default:
      break;
  }
  return null;
};
